module.exports = __webpack_public_path__ + "static/media/veterinario.0a5b0791.PNG";